import assertNever from 'assert-never';

import { FirmwareUpdateJobRequest, ScheduledJobRequest } from '@shure/cloud/shared/models/devices';

import { ScheduledJobRequestFragment } from '../graphql/generated/cloud-sys-api';

export function mapScheduledJobRequestFromSysApi(
	scheduledJobRequest: ScheduledJobRequestFragment
): ScheduledJobRequest {
	const requestBase: ScheduledJobRequest = {
		id: scheduledJobRequest.id,
		status: scheduledJobRequest.status,
		jobId: scheduledJobRequest.job.id
	};

	if (scheduledJobRequest.details.__typename === 'FirmwareUpdateJobRequestDetails') {
		const firmwareUpdateRequest = <FirmwareUpdateJobRequest>requestBase;
		firmwareUpdateRequest.deviceHardwareId = scheduledJobRequest.details.task.device.hardwareId;
		firmwareUpdateRequest.packageKey = scheduledJobRequest.details.task.packageKey;
		firmwareUpdateRequest.packageVersion = scheduledJobRequest.details.task.packageVersion;
		firmwareUpdateRequest.hosted = scheduledJobRequest.details.task.hosted;
		return firmwareUpdateRequest;
	}

	return assertNever(scheduledJobRequest.details.__typename);
}
